import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "raskHighlight" })

export class HighlightPipe implements PipeTransform {

    transform(value: any, args: any): any {
        if (!args || value == null) {
            return value;
        }

        const re = new RegExp(args, "gi");
        value.replace(re, `<mark>${args}</mark>`);
        return value.replace(new RegExp(args, "gi"), "<mark>$&</mark>");
    }
}
